import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AlertsComponent} from "../alerts/alerts.component";

@Component({
  selector: 'app-progress-alert',
  templateUrl: './progress-alert.component.html',
  styleUrls: ['./progress-alert.component.scss']
})
export class ProgressAlertComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AlertsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  ngOnInit() {
  }

  closeDialog():void{
    this.dialogRef.close();
  }
}

export interface DialogData {
  title: string;
}
